import { render, staticRenderFns } from "./MastersDetails.vue?vue&type=template&id=4e22d585&scoped=true&"
import script from "./MastersDetails.vue?vue&type=script&lang=js&"
export * from "./MastersDetails.vue?vue&type=script&lang=js&"
import style0 from "./MastersDetails.vue?vue&type=style&index=0&id=4e22d585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e22d585",
  null
  
)

export default component.exports